import { IFascicolo, IProtocol, IProtocolsTableState, IWorkspaceTableState } from '../../shared/interfaces'
import { AppNavigationState, AppNavigationActionTypes, UPDATE_APP_NAVIGATION_STATE, SET_PROTOCOL, UNSET_PROTOCOL, SET_PROTOCOLS_TABLE_STATE, UNSET_PROTOCOLS_TABLE_STATE, SET_FASCICOLO, UNSET_FASCICOLO, SET_WORKSPACE_TABLE_STATE, UNSET_WORKSPACE_TABLE_STATE, SET_PREVIOUS_LOCATION_PATHNAME, UNSET_PREVIOUS_LOCATION_PATHNAME } from './types'


const updateAppNavigationState = (newAppNavigationState: AppNavigationState): AppNavigationActionTypes => {
    return {
        type: UPDATE_APP_NAVIGATION_STATE,
        payload: newAppNavigationState
    }
}


const setProtocol = (protocol?: IProtocol): AppNavigationActionTypes => {
    return {
        type: SET_PROTOCOL,
        protocol: protocol
    }
}

const unsetProtocol = (): AppNavigationActionTypes => {
    return {
        type: UNSET_PROTOCOL
    }
}

const setFascicolo = (fascicolo?: IFascicolo): AppNavigationActionTypes => {
    return {
        type: SET_FASCICOLO,
        fascicolo: fascicolo
    }
}

const unsetFascicolo = (): AppNavigationActionTypes => {
    return {
        type: UNSET_FASCICOLO
    }
}


const setProtocolsTableState = (protocolsTableState?: Partial<IProtocolsTableState>): AppNavigationActionTypes => {
    return {
        type: SET_PROTOCOLS_TABLE_STATE,
        protocolsTableState: protocolsTableState
    }
}

const unsetProtocolsTableState = (): AppNavigationActionTypes => {
    return {
        type: UNSET_PROTOCOLS_TABLE_STATE
    }
}

const setWorkspaceTableState = (workspaceTableState?: Partial<IWorkspaceTableState>): AppNavigationActionTypes => {
    return {
        type: SET_WORKSPACE_TABLE_STATE,
        workspaceTableState: workspaceTableState
    }
}

const unsetWorkspaceTableState = (): AppNavigationActionTypes => {
    return {
        type: UNSET_WORKSPACE_TABLE_STATE
    }
}

const setPreviousLocationPathName = (previousLocationPathName: string): AppNavigationActionTypes => {
    return {
        type: SET_PREVIOUS_LOCATION_PATHNAME,
        previousLocationPathName: previousLocationPathName
    }
}

const unsetPreviousLocationPathName = (): AppNavigationActionTypes => {
    return {
        type: UNSET_PREVIOUS_LOCATION_PATHNAME
    }
}

let appNavigationActions = {
    updateAppNavigationState,
    setProtocol,
    unsetProtocol,
    setFascicolo,
    unsetFascicolo,
    setProtocolsTableState,
    unsetProtocolsTableState,
    setWorkspaceTableState,
    unsetWorkspaceTableState,
    setPreviousLocationPathName,
    unsetPreviousLocationPathName
};


export default appNavigationActions;